import {Component, inject, Input, OnDestroy, PLATFORM_ID, Inject} from '@angular/core';
import {CommonModule, Location, ViewportScroller} from '@angular/common';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {isPlatformBrowser} from '@angular/common';

import {Globals} from '../../../core/services/globals';
import {Listing} from '../../../core/models/listing';
import {Subject} from 'rxjs';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {takeUntil} from 'rxjs/operators';

//import { ScrollToModule } from "@nicky-lenaers/ngx-scroll-to";

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'my-navigation-details-full',
  templateUrl: './navigation-details-full.component.html',
  styleUrls: ['../base-dashboard/dashboard.component.css'],
})
export class NavigationDetailsFullComponent implements OnDestroy {
  public isCollapsed = true;
  @Input() selectedListing: Listing | undefined;
  public activeStr = 'top';
  private scrollExecuted = false;
  public fallbackURLStr = 'https://m.caymanmarshall.com/search';
  destroyed = new Subject<void>();
  currentScreenSize: string | undefined;

  // Create a map to display breakpoint names for demonstration purposes.
  displayNameMap = new Map([
    [Breakpoints.XSmall, 'XSmall'],
    [Breakpoints.Small, 'Small'],
    [Breakpoints.Medium, 'Medium'],
    [Breakpoints.Large, 'Large'],
    [Breakpoints.XLarge, 'XLarge'],
  ]);

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private _location: Location,
    private http: HttpClient,
    private globals: Globals,
    private scroller: ViewportScroller,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    inject(BreakpointObserver)
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge,
      ])
      .pipe(takeUntil(this.destroyed))
      .subscribe((result) => {
        for (const query of Object.keys(result.breakpoints)) {
          if (result.breakpoints[query]) {
            this.currentScreenSize =
              this.displayNameMap.get(query) ?? 'Unknown';
            // console.log('screen size: ' + this.currentScreenSize);
          }
        }
      });
    router.events.subscribe((s) => {
      if (s instanceof NavigationEnd) {
        const tree = router.parseUrl(router.url);
        if (tree.fragment) {
          this.gotoHashtag(tree.fragment);
        }
      }
    });
  }

  public goBack() {
    // console.log(this.globals);
    // define properties
    const previousURLStr = this.globals.previousURLStr;
    //this.resetPaging();
    // console.log(this.globals.previousURLStr);
    // fork, if the previous url is not blank then use the browser history or else do a hard redirect
    if (previousURLStr != '') {
      this._location.back();
    } else {
      this.redirectToFallback();
    }
  }

  public goBackDirect() {
    const previousStatusStr = this.globals.previousStatusStr;
    // console.log('Previous Status: ' + previousStatusStr);
    if (previousStatusStr != '') {
      switch (previousStatusStr) {
        case '"Active", "Sold"':
          this.router.navigateByUrl('/search');
          break;
        case 'Sold':
          this.router.navigateByUrl('/search/sold');
          break;
        case 'Rental':
          this.router.navigateByUrl('/search/rentals');
          break;
        case 'Toronto':
          this.router.navigateByUrl('/search/toronto');
          break;
      }
    } else {
      this.router.navigateByUrl('/search');
    }
  }

  public resetPaging() {
    this.globals.limitNum = 10;
    this.globals.startNum = 0;
    this.globals.endNum = 10;
    this.globals.countNum = 0;
  }

  gotoHashtag(fragment: string) {
    // console.log(fragment);
    this.scroller.scrollToAnchor(fragment);
    //el.scrollIntoView({behavior: 'smooth'});
  }

  redirect(idStr: string) {
    this.router.navigate(['./' + idStr]);
  }

  public collapsed(event: any): void {
    // console.log('collapsed');
    // console.log(this.isCollapsed);
    // console.log(event);
  }

  public expanded(event: any): void {
    // console.log('expanded');
    // console.log(this.isCollapsed);
    // console.log(event);
  }

  public collapseMenu() {
    // console.log('collapse menu');
    this.isCollapsed = true;
  }

  public trackAnalyticsEvent(obj: { _eventStr: any }) {
    // define properties
    const analyticsObj = this.setupAnalyticsEvent(obj);
    // console.log(analyticsObj);
    this.trackAnalytics(analyticsObj);
  }

  private setupAnalyticsEvent(obj: { _eventStr: any }) {
    if (this.selectedListing == undefined) {
      return;
    }
    1;
    // define properties
    const eventStr = obj._eventStr;
    const catStr = 'RETS';
    let actionStr = '';
    const MLSNum = this.selectedListing.MLSNUM;
    const addressStr = this.selectedListing.fullAddress;
    const labelStr = 'MLS Number: ' + MLSNum + ' | Address: ' + addressStr;

    // switch, based on the selected event create a full analytics action
    switch (eventStr) {
      case 'gallery-click':
        // set the properties
        actionStr = 'View Gallery | ' + addressStr;
        break;
      case 'details-click':
        actionStr = 'View Details | ' + addressStr;
        break;
      case 'request-more-info-click':
        actionStr = 'Request Info | ' + addressStr;
        break;
    }
    return {
      event: eventStr,
      customEventCategory: catStr,
      customEventAction: actionStr,
      customEventLabel: labelStr,
      hitCallback: function () {
        // console.log('Event received');
      },
    };
  }

  redirectToFallback() {
    if (isPlatformBrowser(this.platformId)) {
      window.location.href = this.fallbackURLStr;
    }
  }

  trackAnalytics(analyticsObj: any) {
    if (isPlatformBrowser(this.platformId)) {
      (window as any).dataLayer.push(analyticsObj);
    }
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
